export default {
  // Tabs
  transactionSummary: "Transaction Summary",
  transactionCounterpart: "Transaction Counterpart",
  transactionDetails: "Transaction Details",

  // Search form placeholders
  dataSourcePlaceholder: "Data Source",
  directionPlaceholder: "Transaction Direction",
  currencyPlaceholder: "Currency",
  targetAddressPlaceholder: "Enter counterpart address",
  minAmountPlaceholder: "Min Amount",
  maxAmountPlaceholder: "Max Amount",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",

  // Buttons
  resetBtn: "Reset",
  searchBtn: "Search",
  downloadBtn: "Download Data Details",

  // Data source options
  sourceTypeChain: "On-chain Data",
  sourceTypeInternal: "Internal Platform",

  // Direction options
  directionInflow: "Deposit",
  directionOutflow: "Withdrawal",

  // Table column headers
  columnDirection: "Direction",
  columnCounterpart: "Counterpart",
  columnCurrency: "Currency",
  columnQuantity: "Quantity",
  columnTime: "Time",
  columnHash: "Hash",

  // Prompt text
  maxAmountWarning: "Max amount must be ≥ min amount",
  totalDataText: "Total",
  dataCountText: "records",
  loadingText: "Loading...",

  // Empty state
  emptyText: "No deposit/withdrawal transaction data found in current investigation file",

  // Download
  downloadFileName: "Data Details",

  // Message prompts
  copySuccess: "Copy successful!",

  // Summary page specific
  selectTypePlaceholder: "Please select",
  selectTypeTotalQuantity: "Total Quantity",
  selectTypeTotalCount: "Total Count",
  minQuantityPlaceholder: "Min Quantity",
  maxQuantityPlaceholder: "Max Quantity",
  maxQuantityWarning: "Max quantity must be ≥ min quantity",
  columnTotalCount: "Total Count",
  columnTotalQuantity: "Total Quantity",
};
